<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" label-width="90px" size="mini">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            @change="dateRangeChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="分子公司:">
          <el-select v-model="searchForm.subcompanyCode" filterable clearable placeholder="请选择" @change="zigsChangeCX">
            <el-option v-for="item in getCompany" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门:">
          <el-select v-model="searchForm.departmentCode" filterable clearable placeholder="请选择">
            <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm">重置</el-button>
            <el-button type="primary" size="mini" @click="exportFn" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table
        :data="tableList"
        ref="table"
        border
        size="mini"
        height="100%"
        style="width: 100%"
        class="tableComent"
        highlight-current-row
        center
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="createSubcompanyName" label="公司主体" width="220" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createDepartmentName" label="部门" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payee" label="客户" min-width="220" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="projectType" label="项目名称" min-width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="vehicleOwnershipName" label="车辆归属" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="wayBusinessTypeName" label="业务类型" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ydzs" label="运单数量" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="liquidatedAmount" label="结算量" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="jslzb" label="结算量占比" width="110" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
        <el-table-column prop="grossRevenue" label="收入不含税总额（元）" width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="srzb" label="收入占比" width="100" :show-overflow-tooltip="true" :formatter="formatPercent"></el-table-column>
        <el-table-column prop="freightAmountTotal" label="支出不含税总额（元）" width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ml" label="毛利" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { findProjectIncomeExpenditure } from '@/api/newTMS'
import { toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getCurrUserDepartment, getCurrUserRightCompany } from '@/api/newCrm'
export default {
  name: 'XiangMuShouZhiBaoBiao',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      dateRange: [],
      searchForm: {
        startTime: '',
        endTime: '',
        departmentCode: '',
        subcompanyCode: ''
      },
      tableList: [],
      h: '',
      isDaoChu: false,
      getCompany: [],
      bumenList: []
    }
  },
  created () {
    // 初始化默认时间范围（最近30天）
    this.dateRange = this.getDefaultDateRange()
    if (this.dateRange && this.dateRange.length === 2) {
      this.searchForm.startTime = this.dateRange[0]
      this.searchForm.endTime = this.dateRange[1]
    }
    getCurrUserRightCompany().then(res => { this.getCompany = res })
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 140 + 'px'
  },
  methods: {
    // 获取默认日期范围（最近30天）
    getDefaultDateRange () {
      const today = new Date()
      const thirtyDaysAgo = new Date()
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 29)
      const format = (d) => {
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      }
      return [format(thirtyDaysAgo) + ' 00:00:00', format(today) + ' 23:59:59']
    },
    // 日期范围变化
    dateRangeChange (val) {
      if (!val || val.length !== 2) {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
        return
      }
      const [start, end] = val
      // 验证时间跨度不超过1年
      const startDate = new Date(start)
      const endDate = new Date(end)
      const oneYearLater = new Date(startDate)
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1)
      if (endDate > oneYearLater) {
        this.$message.warning('时间跨度不可超过1年')
        this.dateRange = []
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
        return
      }
      this.searchForm.startTime = start
      this.searchForm.endTime = end
    },
    // 子公司更改
    zigsChangeCX (e) {
      getCurrUserDepartment({ compayCode: e, isQueryDept: 0 }).then(res => { this.bumenList = res })
      this.searchForm.departmentCode = ''
    },
    // 占比格式化
    formatPercent (row, column, cellValue) {
      if (cellValue === null || cellValue === undefined || cellValue === '') return '-'
      const str = String(cellValue)
      if (str.includes('%')) return str
      const num = Number(cellValue)
      if (isNaN(num)) return str
      return toFixed(num, 2) + '%'
    },
    // 合计
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '-'
          return
        }
        // 文本列不合计
        if (['createSubcompanyName', 'createDepartmentName', 'payee', 'projectType', 'productTypeName', 'vehicleOwnershipName', 'wayBusinessTypeName'].includes(column.property)) {
          sums[index] = '-'
          return
        }
        // 占比列不合计
        if (column.property === 'jslzb' || column.property === 'srzb') {
          sums[index] = '-'
          return
        }
        if (!column.property) {
          sums[index] = '-'
          return
        }
        // 数值列求和
        const values = data.map(item => Number(item[column.property]))
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)
      })
      // 合计行首列标记为「合计」
      sums[1] = '合计'
      // 格式化数值
      return sums.map(item => {
        if (typeof item === 'number') {
          return toFixed(item, 2)
        }
        return item
      })
    },
    // 重新计算高度
    getgaodu () {
      this.$nextTick(() => {
        if (this.$refs.searchBox) {
          let h = this.$refs.searchBox.offsetHeight
          let pH = document.documentElement.clientHeight
          this.h = (pH - h - 140) + 'px'
          if (this.$refs.table) {
            this.$refs.table.doLayout()
          }
        }
      })
    },
    masterList () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      findProjectIncomeExpenditure(this.searchForm)
        .then(res => {
          // 兼容多种返回结构
          let list = []
          if (Array.isArray(res)) {
            list = res
          } else if (res && Array.isArray(res.list)) {
            list = res.list
          } else if (res && Array.isArray(res.data)) {
            list = res.data
          } else if (res && res.pageInfo && Array.isArray(res.pageInfo.list)) {
            list = res.pageInfo.list
          } else if (res && Array.isArray(res.rows)) {
            list = res.rows
          }
          this.tableList = list
          this.getgaodu()
          loading.close()
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      if (!this.searchForm.startTime || !this.searchForm.endTime) {
        this.$message.warning('请选择时间范围')
        return
      }
      this.masterList()
    },
    // 重置
    resetForm () {
      this.dateRange = this.getDefaultDateRange()
      this.searchForm = {
        startTime: this.dateRange[0],
        endTime: this.dateRange[1],
        departmentCode: '',
        subcompanyCode: ''
      }
      this.bumenList = []
      this.searchFn()
    },
    // 导出
    exportFn () {
      if (!this.tableList.length) {
        this.$message.warning('暂无数据可导出')
        return
      }
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/reportw/exportProjectIncomeExpenditure',
        form,
        '项目收支报表'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-table__footer-wrapper tbody td {
  color: #409EFF;
  font-weight: bold;
}
</style>
